import { trackRudderstack } from "jiffy-analytics";

export default function trackDeliveryOptionsLoaded(response) {
  const orderId = response?.order_id;
  const orders = response?.shipments?.orders || {};
  Object.values(orders).forEach(order => {
    (order.options || []).forEach(option => {
      trackRudderstack("Cart Delivery Option Loaded", {
        order_id: orderId,
        type: order.title,
        category: option.category,
        delivery_date: option.delivery_date,
        shipping_method: option.shipping_method,
        location_codes: option.location_codes,
        valid_until_time: option.valid_until_time,
        zipcode: order.zipcode
      });
    });
  });
}
